import { registerDynamicCallback } from './servdUtils.js';

/**
 * Handle email reveal buttons that decode and display email addresses
 */
export function initEmailReveal() {
  const emailButtons = document.querySelectorAll('.email-reveal');
  
  if (!emailButtons.length) return;
  
  emailButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      
      const encodedEmail = button.dataset.email;
      if (!encodedEmail) return;
      
      // Decode the email address
      const email = atob(encodedEmail);
      
      // Create mailto link
      const mailtoLink = document.createElement('a');
      mailtoLink.href = `mailto:${email}`;
      mailtoLink.textContent = email;
      
      // Replace button with mailto link
      button.replaceWith(mailtoLink);
    });
  });
}

/**
 * Initialize email reveal and register with Servd utilities
 */
export function initEmailRevealWithServd() {
  // Register the email reveal function to be re-run when dynamic content loads
  registerDynamicCallback(initEmailReveal, 'email-reveal');
  
  // Initial email reveal setup
  initEmailReveal();
} 